<template>
  <div class="page-container">
    <AppSidebar />

    <div class="main-content">
      <div class="static-page">
        <div class="page-header">
          <h1>用户协议</h1>
        </div>

        <div class="content-container">
          <div class="content-text">
            <h2>一、协议适用</h2>
            <p>欢迎使用武汉天冉网络科技有限公司提供的网站服务。您访问、浏览、注册或使用本网站，即表示您已阅读、理解并同意遵守本用户协议。</p>
            <ul>
              <li>本协议适用于您使用本网站提供的全部页面、内容和相关服务</li>
              <li>如您不同意本协议内容，请停止访问或使用本网站服务</li>
              <li>未成年人使用本网站服务，应取得监护人的同意和指导</li>
            </ul>

            <h2>二、账号注册与使用</h2>
            <p>用户在注册和使用账号时，应提供真实、准确、合法的信息，并妥善保管账号和密码。</p>
            <ul>
              <li>不得冒用他人身份或使用违法、侵权、误导性的账号信息</li>
              <li>因用户保管不善造成的账号风险和损失，由用户自行承担</li>
              <li>发现账号被盗用或存在异常，应及时通过网站联系方式反馈</li>
              <li>不得将账号用于违法违规、损害他人权益或干扰网站运营的行为</li>
            </ul>

            <h2>三、服务内容</h2>
            <p>本网站为用户提供漫画内容浏览、搜索、分类展示、章节阅读、会员服务、充值展示及相关信息服务。</p>
            <ul>
              <li>网站有权根据运营需要调整、优化或暂停部分服务内容</li>
              <li>部分内容或功能可能需要登录、购买、充值或开通会员后使用</li>
              <li>具体服务规则以页面展示、公告说明或相关提示为准</li>
            </ul>

            <h2>四、用户行为规范</h2>
            <p>用户在使用本网站时，应遵守法律法规、公序良俗和网站管理规则，不得从事以下行为：</p>
            <ul>
              <li>发布、传播违法、侵权、虚假、暴力、色情、赌博、诈骗等不良信息</li>
              <li>攻击、扫描、干扰网站系统或影响网站正常运行</li>
              <li>恶意注册、盗用账号、绕过权限限制或破坏付费内容规则</li>
              <li>未经许可复制、抓取、转载、传播网站内容或用于商业用途</li>
              <li>其他违反法律法规、本协议或网站声明的行为</li>
            </ul>

            <h2>五、付费与虚拟权益</h2>
            <p>用户可根据页面提示选择充值、购买章节或开通会员等服务。相关虚拟权益仅限在本网站规则范围内使用。</p>
            <ul>
              <li>充值、购买或会员服务的具体价格、有效期和权益以页面展示为准</li>
              <li>虚拟货币、会员权益及已购买内容不具有现金属性，不支持私下交易</li>
              <li>因用户自身操作错误、账号保管不善导致的损失，由用户自行承担</li>
              <li>如法律法规另有规定或页面规则另有说明，按相应规定执行</li>
            </ul>

            <h2>六、知识产权</h2>
            <p>本网站中的文字、图片、页面设计、程序、标识及相关内容受法律保护。</p>
            <ul>
              <li>未经权利人或本网站书面许可，不得擅自复制、传播、改编或商业使用</li>
              <li>用户在反馈或投稿中提供的内容，应确保不侵犯第三方合法权益</li>
              <li>如权利人认为网站内容侵犯其权益，可通过联系方式提交权利通知</li>
            </ul>

            <h2>七、隐私保护</h2>
            <p>我们重视用户个人信息保护，将按照隐私协议及相关法律法规处理用户信息。用户应避免在公开区域发布个人敏感信息。</p>

            <h2>八、违约处理</h2>
            <p>如用户违反本协议或相关法律法规，网站有权根据情节采取以下措施：</p>
            <ul>
              <li>提示整改、限制功能、暂停或终止服务</li>
              <li>删除、屏蔽或下架相关违规内容</li>
              <li>冻结或注销违规账号</li>
              <li>依法向有关部门提交线索或配合调查处理</li>
            </ul>

            <h2>九、协议变更</h2>
            <p>网站可根据法律法规变化、业务调整或运营需要更新本协议。协议更新后，将通过页面展示或其他合理方式提示用户，用户继续使用服务视为接受更新后的协议。</p>

            <h2>十、联系我们</h2>
            <p>如对本协议有任何疑问、建议或投诉，请通过以下方式联系我们：</p>
            <ul>
              <li>公司名称：武汉天冉网络科技有限公司</li>
              <li>联系电话：13641239621</li>
              <li>电子邮箱：wudongjian@huashi.tv</li>
              <li>公司地址：湖北省武汉市洪山区雄楚大街452号保利蓝海郡G6栋1单元20层3室-2</li>
            </ul>

            <p class="update-time">最后更新时间：2026年6月23日</p>
          </div>
        </div>
      </div>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppSidebar from '@/components/layout/Sidebar.vue';
import AppFooter from '@/components/layout/Footer.vue';

export default {
  name: 'AgreementPage',
  components: {
    AppSidebar,
    AppFooter
  },
  mounted() {
    document.title = '用户协议 - 武汉天冉网络科技有限公司';
  }
};
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f6fa;
}

.main-content {
  flex: 1;
  margin-left: 200px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.static-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  flex: 1;
  width: 100%;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-header h1 {
  font-size: 30px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
  position: relative;
  display: inline-block;
  padding-bottom: 15px;
}

.page-header h1:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #ff6b81, #ff9eb6);
  border-radius: 3px;
}

.content-container {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
}

.content-text {
  line-height: 1.8;
  color: #444;
  font-size: 16px;
}

.content-text h2 {
  font-size: 22px;
  margin: 25px 0 15px;
  color: #333;
}

.content-text p {
  margin-bottom: 15px;
}

.content-text ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.content-text li {
  margin-bottom: 8px;
}

.update-time {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  color: #999;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }

  .static-page {
    padding: 20px 15px;
  }

  .content-container {
    padding: 20px;
  }
}
</style>
